import { STUDIO_APPS } from '../keys'
const initialState = { apps: [] }
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case STUDIO_APPS: {
            return { ...state, apps: action.payload }
        }
        default:
            return { ...state }
    }

}